import {View,map} from "vritra";


export default function FruitList(props){
    const fruitlist=View({...props,tag:"ul"});

    fruitlist.innateHTML=`
        ${map(produce.filter(item=>item.type==="fruit"),({name})=>`
            <li>${name}</li>
        `)}
    `;

    return fruitlist;
}

const produce=[
    {name:"pear",type:"fruit"},
    {name:"potato",type:"vegetable"},
    {name:"pineapple",type:"fruit"},
    {name:"cabbage",type:"vegetable"},
    {name:"raspberry",type:"fruit"},
    {name:"peas",type:"vegetable"},
];
